// src/Hooks/useSessionTracker.js
// Tracks active screen time. Sends ONE request on tab switch / page close.

import { useEffect, useRef } from "react";

export default function useSessionTracker() {
  const stateRef = useRef({ activeStart: 0, totalActiveMs: 0, isActive: false });

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (!token || !window.baseDomain) return;

    const state = stateRef.current;
    const url = `${window.baseDomain}api/session-beacon`;

    state.activeStart = Date.now();
    state.isActive = true;

    const pauseTracking = () => {
      if (state.isActive) {
        state.totalActiveMs += Date.now() - state.activeStart;
        state.isActive = false;
      }
    };

    const resumeTracking = () => {
      state.activeStart = Date.now();
      state.isActive = true;
    };

    const sendBeacon = () => {
      pauseTracking();
      const activeSeconds = Math.round(state.totalActiveMs / 1000);
      if (activeSeconds < 5) return;

      state.totalActiveMs = 0; // reset to avoid double-send

      const currentToken = localStorage.getItem("accessToken");
      if (!currentToken) return;

      try {
        fetch(url, {
          method: "POST",
          headers: {
            Authorization: "Bearer " + currentToken,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ platform: "dashboard", activeSeconds }),
          keepalive: true,
        }).catch(() => {});
      } catch (_) {}
    };

    const handleVisibility = () => {
      if (document.hidden) {
        sendBeacon();
      } else {
        resumeTracking();
      }
    };

    const handlePageHide = () => sendBeacon();

    document.addEventListener("visibilitychange", handleVisibility);
    window.addEventListener("pagehide", handlePageHide);

    return () => {
      sendBeacon();
      document.removeEventListener("visibilitychange", handleVisibility);
      window.removeEventListener("pagehide", handlePageHide);
    };
  }, []);
}
